import React from 'react';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
    /**
     * Bold neobrutalist treatment — ink border + hard offset shadow.
     * Reserve for earned emphasis (modals, a featured/primary card). The
     * default is the calm flat surface used across the dashboard.
     */
    raised?: boolean;
    /** Adds a gentle hover lift — for clickable cards/rows. */
    interactive?: boolean;
}

/** White surface. Soft hairline by default; bold ink+shadow when `raised`. */
export const Card: React.FC<CardProps> = ({raised = false, interactive = false, className = '', children, ...rest}) => (
    <div
        {...rest}
        className={`rounded-2xl bg-white ${
            raised ? 'border-2 border-[#0a0a0a] nb-shadow-lg' : 'card'
        } ${interactive ? 'card-hover cursor-pointer' : ''} ${className}`}
    >
        {children}
    </div>
);

export default Card;
